export default () => {
  return {
    path: "/preview",
    name: "preview",
    component: () => import("@/pages/preview/index.vue")
  };
};
